<template>
    <div class="modal" @click="outsideClick()">
        <div class="modal-box">
            <div class="close" @click="$emit('close')">
                <span>X</span>
            </div>
            <div class="modal-body">
                <template v-if="risk.label === 'gambs'">
                    <img v-if="risk.title == 'cardio'" src="@/assets/images/tela_riscocardio.png" class="gambs-image"/>
                    <img v-else src="@/assets/images/tela_riscos.png" class="gambs-image"/>
                </template>
                <template v-else>
                    <p class="text">
                        <template v-if="risk.title.toLowerCase() == 'risco psicológico'">
                            O Risco Psicológico é estimado para identificar os transtornos psicológicos mais comuns.<br> O seu Risco Psicológico está 
                            <span class="bold">{{risk.label}}</span>.<br>
                            <template v-if="risk.label == 'Baixo'">
                                De acordo com suas respostas destacamos que você está no caminho certo para evitar o adoecimento mental, 
                                isso porque, neste momento, você apresenta um perfil com baixa tendência para desenvolvimento de transtornos psicológicos, 
                                tais como depressão e ansiedade. Esta é uma boa notícia! Assim como a física, a saúde mental é uma parte integrante e complementar 
                                à manutenção das funções do organismo. Ter saúde mental é conseguir lidar tanto com emoções positivas e negativas investindo em estratégias 
                                que possibilitem o equilíbrio das funções mentais.
                            </template>
                            <template v-if="risk.label == 'Médio'">
                                De acordo com as respostas apresentadas observamos que é importante começar a refletir sobre a necessidade de conhecer melhor suas emoções,
                                 dedique um tempo para você, realize atividades prazerosas, cuide da sua alimentação e durma bem, evitando transtornos como depressão 
                                 e ansiedade. Isso não quer dizer que você já possua alguma dessas condições, apenas é importante estar atento a seriedade dos sintomas 
                                 associados a essas patologias. Assim como a física, a saúde mental é extremamente determinante para a correta manutenção das funções vitais 
                                 do organismo. Ter saúde mental é conseguir lidar tanto com emoções positivas e negativas investindo em estratégias que possibilitem o 
                                 equilíbrio das funções mentais.
                            </template>
                            <template v-if="risk.label == 'Alto'">
                                De acordo com suas respostas destacamos que é importante prevenir o adoecimento mental, isso porque, neste momento, 
                                você apresenta um perfil com maior tendência para desenvolvimento de transtornos psicológicos, tais como depressão e ansiedade. 
                                Isso não quer dizer que você já possua alguma dessas condições, apenas é importante estar atento a seriedade dos sintomas associados 
                                a essas patologias. Assim como a física, a saúde mental é extremamente determinante para a correta manutenção das funções vitais do 
                                organismo. Ter saúde mental é conseguir lidar tanto com emoções positivas e negativas investindo em estratégias que possibilitem o 
                                equilíbrio das funções mentais. Para maiores informações sugerimos a realização de avaliação psicológica com um especialista.
                            </template>
                            <div class="bottom" v-if="risk.title.toLowerCase() == 'risco psicológico'">
                                Nota: Utilização de instrumento Beck Depression Inventory – Escala de Depressão de Beck ou Inventário de Depressão de Beck – e Escala de Hamilton (simplificado).
                            </div>
                        </template>
                        <template v-else>
                            <template v-if="risk.title.toLowerCase() == 'risco de internação'">
                                O risco de Internação é baseado na identificação dos indivíduos com maior risco para internação hospitalar.
                            </template>
                            <template v-if="risk.title.toLowerCase() == 'risco de fragilidade'">
                                O Risco de Fragilidade é estimado para identificar a vulnerabilidade funcional de pessoas da terceira idade.
                            </template>
                            <template v-if="risk.title.toLowerCase() == 'risco de cardiovascular'">
                                O Risco Cardiovascular é estabelecido para infarto do miocárdio e angina do eito em dez anos.
                            </template>
                            <span v-if="plural">Os seus</span>
                            <span v-else>O seu</span> 
                            <span class="bold">{{risk.title}}</span> 
                            <span v-if="plural">estão com risco</span>
                            <span v-else>está</span>
                            <span class="bold">{{risk.label}}</span>, com base nos indicadores:
                            <div class="items" v-if="metricList.length > 0">
                                <span v-for="(metric, x) in metricList" v-bind:key="x" class="item">{{metric[0]}} - {{metric[1]}};</span>
                            </div>
                            <div class="items" v-else>
                                <span class="item">Sem valores para exibir.</span>
                            </div>
                            <div class="bottom" v-if="risk.title.toLowerCase() == 'risco de internação'">
                                Nota: Cálculo de Risco baseado em estudo produzido por Boult e colaboradores (PACALA et al., 1995; BOULT et al., 1994; BOULT et al., 1993) e validado para o português por Dutra et al. (2011).
                            </div>
                            <div class="bottom" v-if="risk.title.toLowerCase() == 'risco de fragilidade'">
                                Nota: Utilização de instrumento Probability of Repetead Admission (PRA) – Screening for risk of hospitalization in the elderly: a study based on a single entry point in a health maintenance organization in Brazil.
                            </div>
                            <div class="bottom" v-if="risk.title.toLowerCase() == 'risco de cardiovascular'">
                                Nota: Cálculo de Risco baseado em Escore de Framingham.
                            </div>
                        </template>
                    </p>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "risk-modal",
        components: { },
        props: {
            customer: Object,
            result: Object,
            risk: Object,
            answers: Array,
        },
        data() {
            return {
                plural: false,
                metricList: [],
            }
        },
        methods: {
            outsideClick() {
                if(event.target === event.currentTarget)
                    this.$emit('close');
            },
            loadMetrics(title) {
                title = title.toLowerCase();
                let gender = this.customer.gender;
                if(gender == 'M'){
                    gender = 'Masculino';
                }else if(gender == 'F') {
                    gender = 'Feminino';
                }else {
                    gender = 'Outro';
                }

                let imc = this.answerSearch("imc");
                imc = parseFloat(imc.weigth) / ( parseFloat(imc.heigth.replace(',', '.')) * parseFloat(imc.heigth.replace(',', '.')) );
                imc = imc.toString().substr(0, 4);
                switch (title) {
                    case 'risco de internação':
                        this.addMetric('Sexo', gender);
                        this.addMetric('Idade', this.customer.age);
                        this.addMetric('Auto percepção da saúde', this.answerSearch("Em geral você diria que a sua saúde é? (Própria saúde em relação a outras pessoas da sua idade)"));
                        this.addMetric('Internação no último ano', this.answerSearch("Esteve internado no último ano?"));
                        this.addMetric('Atendimento médico ou clinica no último ano', this.answerSearch("Esteve internado no último ano?"));
                        this.addMetric('Diabético', this.answerSearch("Você é portador de Diabetes?"));
                        break;
                    case 'risco cardiovascular':
                        this.addMetric('Sexo', gender);
                        this.addMetric('Idade', this.customer.age);
                        this.addMetric('Fumante', this.answerSearch("Você fuma?"));
                        this.addMetric('Diabético', this.answerSearch("Você é portador de Diabetes?"));
                        this.addMetric('Resultado de HDL',  !!this.result.hdl ? this.result.hdl + 'mg/dL' : 'Não aferido');
                        this.addMetric('Resultado de LDL',  !!this.result.ldl ?  this.result.ldl + 'mg/dL' : 'Não aferido');
                        this.addMetric('Pressão Arterial (sistólica)', this.answerSearch("Sistólica (alta):"));
                        this.addMetric('Pressão Arterial (diastólica)', this.answerSearch("Diastólica (baixa):"));
                        break;
                    case 'risco de fragilidade':
                        this.addMetric('Sexo', gender);
                        this.addMetric('Idade', this.customer.age);
                        this.addMetric('Cuidador informal', this.fieldAnswerSearch(
                            "Selecione abaixo as situações que se encaixam na sua rotina",
                            "Caso necessário, não possuo alguém da minha confiança para tomar conta de mim"
                        ));
                        this.addMetric('Problema de saúde que limita atividade', this.fieldAnswerSearch(
                            "Selecione abaixo as situações que se encaixam na sua rotina",
                            "Possuo problemas de saúde que limitam a realização de atividades que dependam de esforços físicos"
                        ));
                        this.addMetric('Necessita de ajuda para atividades diárias', this.fieldAnswerSearch(
                            "Selecione abaixo as situações que se encaixam na sua rotina",
                            "Necessito de ajuda para realizar as atividades diárias como banho, vestir, comer e/ou andar"
                        ));
                        this.addMetric('Problema de saúde que faz ficar em casa', this.fieldAnswerSearch(
                            "Selecione abaixo as situações que se encaixam na sua rotina",
                            "Possuo problema de saúde que me faz ficar em casa"
                        ));
                        this.addMetric('Usa meios auxiliares', this.fieldAnswerSearch(
                            "Selecione abaixo as situações que se encaixam na sua rotina",
                            "Uso meios auxiliares de locomoção (andador, bengala ou cadeira de rodas)"
                        ));
                        break;
                    case 'fatores preliminares para desenvolver lesão muscular':
                        this.addMetric('Seu IMC', imc);
                        this.addMetric('Idade', this.customer.age);
                        this.addMetric('Auto percepção da saúde', this.answerSearch("Em geral você diria que a sua saúde é? (Própria saúde em relação a outras pessoas da sua idade)"));
                        this.addMetric('Sono', this.answerSearch("Quantas horas você dorme por dia aproximadamente?"));
                        this.addMetric('Atividade física', this.answerSearch("Com que frequência você pratica atividade física semanalmente? (Ex: caminhada por pelo menos 30 minutos/dia)?"));
                        this.addMetric('Consumo de frutas e verduras', this.answerSearch("Quantas porções de frutas ou verduras você come por dia? (Exemplo: 1 porção de fruta = 1 unidade maçã ou banana; 1 porção de legumes ou verduras = medida de 1 pires)."));
                        this.addMetric('Consumo de gordura animal',  this.answerSearch("Você consome alimentos de origem animal (carnes, linguiça, ovos, banha, leite e etc)?"));
                        this.addMetric('Bebida alcoólica', this.answerSearch("Você costuma tomar bebida alcoólica com frequência (1 dose = 350 ml de cerveja, 100 ml de vinho ou 30 ml de destilado)?"));
                        this.addMetric('Fumante', this.answerSearch("Você fuma?"));
                        if(
                            !!this.answerSearch(
                            "Você é portador de quais doenças ou condições abaixo?",
                            true,
                            [
                                "Lesões no fêmur ou joelho",
                                "Hérnia de disco ou transtornos de discos intervertebrais",
                                "Lesões no ombro",
                                "Lesões no tornozelo e pé",
                                "Tendinites",
                                "Artrites",
                                "Lesões no punho e mão"
                            ]
                        ))
                            this.addMetric('Doenças autorreferidas', this.answerSearch(
                                "Você é portador de quais doenças ou condições abaixo?",
                                true,
                                [
                                    "Lesões no fêmur ou joelho",
                                    "Hérnia de disco ou transtornos de discos intervertebrais",
                                    "Lesões no ombro",
                                    "Lesões no tornozelo e pé",
                                    "Tendinites",
                                    "Artrites",
                                    "Lesões no punho e mão"
                                ]
                            ));
                        break;
                    case 'fatores preliminares para desenvolver doenças do coração':
                        this.addMetric('Sexo', gender);
                        this.addMetric('Idade', this.customer.age);
                        this.addMetric('Fumante', this.answerSearch("Você fuma?"));
                        this.addMetric('Diabético', this.answerSearch("Você é portador de Diabetes?"));
                        this.addMetric('Resultado de HDL',  !!this.result.hdl ? this.result.hdl + 'mg/dL' : 'Não aferido');
                        this.addMetric('Resultado de LDL',  !!this.result.ldl ?  this.result.ldl + 'mg/dL' : 'Não aferido');
                        this.addMetric('Pressão Arterial (sistólica)', this.answerSearch("Sistólica (alta):"));
                        this.addMetric('Pressão Arterial (diastólica)', this.answerSearch("Diastólica (baixa):"));
                        break;
                    case 'fatores preliminares para desenvolver avc':
                        this.addMetric('Seu IMC', imc);
                        this.addMetric('Atividade física', this.answerSearch("Com que frequência você pratica atividade física semanalmente? (Ex: caminhada por pelo menos 30 minutos/dia)?"));
                        this.addMetric('Consumo de frutas e verduras', this.answerSearch("Quantas porções de frutas ou verduras você come por dia? (Exemplo: 1 porção de fruta = 1 unidade maçã ou banana; 1 porção de legumes ou verduras = medida de 1 pires)."));
                        this.addMetric('Consumo de gordura animal',  this.answerSearch("Você consome alimentos de origem animal (carnes, linguiça, ovos, banha, leite e etc)?"));
                        this.addMetric('Fumante', this.answerSearch("Você fuma?"));
                        this.addMetric('Pressão Arterial (sistólica)', this.answerSearch("Sistólica (alta):"));
                        this.addMetric('Pressão Arterial (diastólica)', this.answerSearch("Diastólica (baixa):"));
                        if(
                            this.answerSearch("Você é portador de quais doenças ou condições abaixo?") == 'Dependência a álcool ou drogas' ||
                            this.answerSearch("Você é portador de quais doenças ou condições abaixo?") == 'Dislipidemia'
                        )
                            this.addMetric('Doenças autorreferidas', this.answerSearch(
                                "Você é portador de quais doenças ou condições abaixo?",
                                true,
                            ));
                        this.addMetric('Resultado de HDL',  !!this.result.hdl ? this.result.hdl + 'mg/dL' : 'Não aferido');
                        this.addMetric('Resultado de LDL',  !!this.result.ldl ?  this.result.ldl + 'mg/dL' : 'Não aferido');
                        this.addMetric('Resultado de colesterol total',  !!this.result.colesterol_total ? this.result.colesterol_total + 'mg/dL' : 'Não aferido');
                        this.addMetric('Resultado de triglicerídeos',  !!this.result.triglicerideos ?  this.result.triglicerideos + 'mg/dL' : 'Não aferido');
                        break;
                    case 'fatores preliminares para desenvolver dislipidemia':
                        this.addMetric('Seu IMC', imc);
                        this.addMetric('Atividade física', this.answerSearch("Com que frequência você pratica atividade física semanalmente? (Ex: caminhada por pelo menos 30 minutos/dia)?"));
                        this.addMetric('Consumo de frutas e verduras', this.answerSearch("Quantas porções de frutas ou verduras você come por dia? (Exemplo: 1 porção de fruta = 1 unidade maçã ou banana; 1 porção de legumes ou verduras = medida de 1 pires)."));
                        this.addMetric('Consumo de gordura animal',  this.answerSearch("Você consome alimentos de origem animal (carnes, linguiça, ovos, banha, leite e etc)?"));
                        this.addMetric('Fumante', this.answerSearch("Você fuma?"));
                        this.addMetric('Pressão Arterial (sistólica)', this.answerSearch("Sistólica (alta):"));
                        this.addMetric('Pressão Arterial (diastólica)', this.answerSearch("Diastólica (baixa):"));
                        if(
                            this.answerSearch("Você é portador de quais doenças ou condições abaixo?") == 'Dependência a álcool ou drogas'
                        )
                            this.addMetric('Doenças autorreferidas', this.answerSearch(
                                "Você é portador de quais doenças ou condições abaixo?",
                                true
                            ));
                        this.addMetric('Resultado de HDL',  !!this.result.hdl ? this.result.hdl + 'mg/dL' : 'Não aferido');
                        this.addMetric('Resultado de LDL',  !!this.result.ldl ?  this.result.ldl + 'mg/dL' : 'Não aferido');
                        this.addMetric('Resultado de colesterol total',  !!this.result.colesterol_total ? this.result.colesterol_total + 'mg/dL' : 'Não aferido');
                        this.addMetric('Resultado de triglicerídeos',  !!this.result.triglicerideos ?  this.result.triglicerideos + 'mg/dL' : 'Não aferido');
                        break;
                    case 'fatores preliminares para desenvolver síndrome metabólica':
                        this.addMetric('Circunferência abdominal', this.answerSearch("Circunferência abdominal"));
                        this.addMetric('Pressão Arterial (sistólica)', this.answerSearch("Sistólica (alta):"));
                        this.addMetric('Pressão Arterial (diastólica)', this.answerSearch("Diastólica (baixa):"));
                        this.addMetric('Resultado de HDL',  !!this.result.hdl ? this.result.hdl + 'mg/dL' : 'Não aferido');
                        this.addMetric('Resultado de LDL',  !!this.result.ldl ?  this.result.ldl + 'mg/dL' : 'Não aferido');
                        this.addMetric('Resultado de colesterol total',  !!this.result.colesterol_total ? this.result.colesterol_total + 'mg/dL' : 'Não aferido');
                        this.addMetric('Resultado de triglicerídeos',  !!this.result.triglicerideos ?  this.result.triglicerideos + 'mg/dL' : 'Não aferido');
                        if(!!this.result.glicose)
                            this.addMetric('Resultado de glicose',  !!this.result.glicose ? this.result.glicose + 'mg/dL' : 'Não aferido');
                        this.addMetric('Resultado de hemoglobina glicada (HbA1c)',  !!this.result.hba1c ?  this.result.hba1c + 'mg/dL' : 'Não aferido');
                        break;
                    case 'fatores preliminares para desenvolver hipertensão':
                        this.addMetric('Seu IMC', imc);
                        this.addMetric('Idade', this.customer.age);
                        this.addMetric('Atividade física', this.answerSearch("Com que frequência você pratica atividade física semanalmente? (Ex: caminhada por pelo menos 30 minutos/dia)?"));
                        this.addMetric('Consumo de frutas e verduras', this.answerSearch("Quantas porções de frutas ou verduras você come por dia? (Exemplo: 1 porção de fruta = 1 unidade maçã ou banana; 1 porção de legumes ou verduras = medida de 1 pires)."));
                        this.addMetric('Consumo de gordura animal',  this.answerSearch("Você consome alimentos de origem animal (carnes, linguiça, ovos, banha, leite e etc)?"));
                        this.addMetric('Fumante', this.answerSearch("Você fuma?"));
                        this.addMetric('Resultado de HDL',  !!this.result.hdl ? this.result.hdl + 'mg/dL' : 'Não aferido');
                        this.addMetric('Resultado de LDL',  !!this.result.ldl ?  this.result.ldl + 'mg/dL' : 'Não aferido');
                        this.addMetric('Resultado de colesterol total',  !!this.result.colesterol_total ? this.result.colesterol_total + 'mg/dL' : 'Não aferido');
                        this.addMetric('Resultado de triglicerídeos',  !!this.result.triglicerideos ?  this.result.triglicerideos + 'mg/dL' : 'Não aferido');
                    case 'fatores preliminares para desenvolver diabetes':
                        this.addMetric('Seu IMC', imc);
                        this.addMetric('Idade', this.customer.age);
                        this.addMetric('Atividade física', this.answerSearch("Com que frequência você pratica atividade física semanalmente? (Ex: caminhada por pelo menos 30 minutos/dia)?"));
                        this.addMetric('Consumo de frutas e verduras', this.answerSearch("Quantas porções de frutas ou verduras você come por dia? (Exemplo: 1 porção de fruta = 1 unidade maçã ou banana; 1 porção de legumes ou verduras = medida de 1 pires)."));
                        this.addMetric('Consumo de gordura animal',  this.answerSearch("Você consome alimentos de origem animal (carnes, linguiça, ovos, banha, leite e etc)?"));
                        this.addMetric('Bebida alcoólica', this.answerSearch("Você costuma tomar bebida alcoólica com frequência (1 dose = 350 ml de cerveja, 100 ml de vinho ou 30 ml de destilado)?"));
                        this.addMetric('Fumante', this.answerSearch("Você fuma?"));
                        if(gender == 'Feminino')
                            this.addMetric('Gravidez', this.answerSearch("Você está grávida?"));
                        this.addMetric('Resultado de HDL',  !!this.result.hdl ? this.result.hdl + 'mg/dL' : 'Não aferido');
                        this.addMetric('Resultado de LDL',  !!this.result.ldl ?  this.result.ldl + 'mg/dL' : 'Não aferido');
                        this.addMetric('Resultado de colesterol total',  !!this.result.colesterol_total ? this.result.colesterol_total + 'mg/dL' : 'Não aferido');
                        this.addMetric('Resultado de triglicerídeos',  !!this.result.triglicerideos ?  this.result.triglicerideos + 'mg/dL' : 'Não aferido');
                        if(!!this.result.glicose)
                            this.addMetric('Resultado de glicose',  !!this.result.glicose ? this.result.glicose + 'mg/dL' : 'Não aferido');
                        this.addMetric('Resultado de hemoglobina glicada (HbA1c)',  !!this.result.hba1c ?  this.result.hba1c + 'mg/dL' : 'Não aferido');
                        break;
                    case 'fatores preliminares para desenvolver osteoporose':
                        this.addMetric('Sexo', gender);
                        this.addMetric('Idade', this.customer.age);
                        this.addMetric('Seu IMC', imc);
                        this.addMetric('Atividade física', this.answerSearch("Com que frequência você pratica atividade física semanalmente? (Ex: caminhada por pelo menos 30 minutos/dia)?"));
                        this.addMetric('Consumo de frutas e verduras', this.answerSearch("Quantas porções de frutas ou verduras você come por dia? (Exemplo: 1 porção de fruta = 1 unidade maçã ou banana; 1 porção de legumes ou verduras = medida de 1 pires)."));
                        this.addMetric('Consumo de gordura animal',  this.answerSearch("Você consome alimentos de origem animal (carnes, linguiça, ovos, banha, leite e etc)?"));
                        this.addMetric('Bebida alcoólica', this.answerSearch("Você costuma tomar bebida alcoólica com frequência (1 dose = 350 ml de cerveja, 100 ml de vinho ou 30 ml de destilado)?"));
                        this.addMetric('Fumante', this.answerSearch("Você fuma?"));
                        if(
                            this.answerSearch("Você é portador de quais doenças ou condições abaixo?") == 'Dependência a álcool ou drogas'
                        )
                            this.addMetric('Doenças autorreferidas', this.answerSearch(
                                "Você é portador de quais doenças ou condições abaixo?",
                                true
                            ));
                        break;
                    default:
                        break;
                }
            },
            addMetric(title, value) {
                this.metricList.push([
                    title,
                    value,
                ]);
            },
            answerSearch(field, multiple = false, answers = []) {
                let ans = null
                if(multiple) {
                    if(answers.length > 0) {
                        ans = this.answers.filter(a => {
                            return a.field.title == field && answers.includes(a.option.value);
                        }).map(a => {
                            return a.option.value;
                        });
                        return ans.join(', ');
                    }else {
                        ans = this.answers.filter(a => {
                            return a.field.title == field;
                        }).map(a => {
                            return a.option.value;
                        });
                        return ans.join(', ');
                    }
                }else {
                    this.answers.map(answer => {
                        if(answer.field.title == field && !multiple)
                            ans = answer.response !== null ? answer.response : answer.option.label;
                    });
                }
                return ans;
            },
            fieldAnswerSearch(field, option) {
                let ans = 'Não'
                this.answers.map(answer => {
                    if(answer.field.title == field && answer.option.label == option) {
                        ans = 'Sim';
                    }
                });
                return ans;
            }
        },
        mounted() {
            if(this.risk.title.split(" ", 2)[0].toLowerCase() == 'fatores')
                this.plural = true;

            this.loadMetrics(this.risk.title);
        }
    }
</script>

<style scoped>
    .modal-box {
        max-width: 650px;
    }
    .modal-body {
        max-height: 500px;
        overflow-y: auto;
    }
    .text {
        font-size: 22px;
        line-height: 26px;
    }
    .bold {
        font-weight: bold;
    }
    .items {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin-top: 8px;
    }
    .gambs-image {
        width: 100%;
        height: auto;
    }
    .item {
        margin-left: 15px;
    } 
    .item:not(:last-child) {
        margin-bottom: 18px;
    }  
    .title {
        font-weight: bold;
    }
    .bottom {
        font-size: 16px;
        margin-top: 20px;
    }
    @media screen and (max-width: 850px) {
        .modal-box {
            width: 100%;
            margin-right: 20px;
            margin-left: 20px;
        }
    }
    @media screen and (max-height: 650px) {
        .modal-box {
            min-height: 80vh;
            max-height: 80vh;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/KitRisks/RiskModal.vue